<div class="top-nav">
    <div class="logo-img">
        <h1>
            <img src="../../../assets/images/chevron-logo.svg" alt="chevron-logo.svg" width="100" height="50" />
        </h1>
    </div>

    <div class="top-text-nav">
        <div class="nav-text">
            <span>Rockapedia - </span>
            <span>Column Standardization</span>
        </div>

        <p class="top-text-key">Monitor recent processing runs and upload new files for standardization</p>
    </div>

    <div class="nav-profile">

        <!-- Profile Section -->
        <div class="profile-section">
            <div class="avatar">{{userDetails?.givenName?.charAt(0)}}{{userDetails?.surname?.charAt(0)}}</div>
            <div class="user-info">
                <div class="name">{{userDetails?.givenName}} {{userDetails?.surname}}</div>
                <div class="role">{{userDetails?.jobTitle}}</div>
            </div>
        </div>

    </div>

</div>